import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPreviousTen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.70711 4.70711C7.09763 4.31658 7.09763 3.68342 6.70711 3.29289C6.31658 2.90237 5.68342 2.90237 5.29289 3.29289L2.29289 6.29289C1.90237 6.68342 1.90237 7.31658 2.29289 7.70711L5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071C7.09763 10.3166 7.09763 9.68342 6.70711 9.29289L5.41421 8H16C18.2091 8 20 9.79086 20 12C20 14.3912 18.7211 15.7055 17.6838 16.0513C17.1598 16.226 16.8767 16.7923 17.0513 17.3162C17.226 17.8402 17.7923 18.1233 18.3162 17.9487C20.2789 17.2945 22 15.1317 22 12C22 8.68629 19.3137 6 16 6H5.41421L6.70711 4.70711Z",
			fill: "#3E525B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.3416 21.12C9.27765 21.12 8.06565 19.38 8.06565 16.8C8.06565 14.208 9.27765 12.48 11.3416 12.48C13.4176 12.48 14.6296 14.208 14.6296 16.8C14.6296 19.38 13.4176 21.12 11.3416 21.12ZM11.3416 19.392C12.2536 19.392 12.8056 18.576 12.8056 16.8C12.8056 15.024 12.2536 14.208 11.3416 14.208C10.4416 14.208 9.88965 15.024 9.88965 16.8C9.88965 18.576 10.4416 19.392 11.3416 19.392Z",
			fill: "#3E525B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.05043 12.6V21H5.28643V15.036L3.41443 16.476V14.352L5.86243 12.6H7.05043Z",
			fill: "#3E525B"
		})
	]
});
export default SvgPreviousTen;
